let _ = require('lodash')
import { Promise } from 'bluebird'

export const secretKeyLength = 12;

export const getHousingGroupLabel = (housingGroup, addressOnly) => {
  if (!housingGroup) return '';

  var labels = [];
  if (!addressOnly) labels.push(housingGroup.label);
  labels.push(housingGroup.address);
  labels.push(housingGroup.postal_code + ' ' + housingGroup.city);
  labels.push(housingGroup.country);

  return _.filter(
    labels,
    label => label !== undefined && label !== null && label.trim() !== '',
  ).join(', ');
};

const deviceTypeList = {
  10: 'hotWater',
  20: 'coldWater',
  30: 'heater',
};

const deviceStatusList = {
  0: 'inWaiting',
  10: 'inFunction',
  20: 'outOfFucntion',
  90: 'boken',
};

const boxStatusList = {
  0: 'inWaiting',
  10: 'inFunction',
  20: 'outOfFucntion',
  90: 'boken',
};

const valueStatusList = {
  10: 'manual',
  20: 'auto',
};

const accessStatusList = {
  10: 'active',
  20: 'revoked',
};

const documentTypeList = {
  10: 'invoice',
  20: 'mail',
  30: 'contract'
};

const documentStatusList = {
  10: 'active',
  20: 'revoked',
};

export const ALARMS_TYPE_FILTERS = ["dailyMeter", "inverseFlow", "partialNoFlow", "negativeFlow", "absenceConsumption", "monthlyConsumptionThreshold", "yearlyConsumptionThreshold", "waterLoss", "batteryCharge", "headRemoved", "opticalFraud",
  "magneticFraud", "flowTooBig", "radioRemovedFromMeter", "leakage", "reverseFlowAboveThreshold",
  "maxFlowRate", "mountedWrongVerse", "noWaterConsumption", "sensor1CableBroken",
  "sensor1ShortCircuit", "sensor2CableBroken", "sensor2ShortCircuit",
  "flowMeasurementSystem", "electronicDefective", "reset", "lowBattery",
  "outOfOperatingTemperature", "expiredSealingPeriod", "metrologicalWrongChecksum"]
  
export const ALARMSBOX_TYPE_FILTERS = ["dailyMeter"] 

export const safeParse = str => {
  try {
    if(_.isObject(str))
      return str
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
}

// Some columns are double-encoded (string wrapping a JSON string).
// Parses repeatedly until we get a non-string, or until parsing fails.
export const safeParseDeep = value => {
  let current = value
  let parsed = safeParse(current)
  let safety = 5
  while (typeof parsed === 'string' && parsed !== current && safety-- > 0) {
    current = parsed
    parsed = safeParse(current)
  }
  return parsed
}

export const statusLabel = status => {
  var label;
  switch (status) {
    case 0:
      label = 'Non activé';
      break;
    case 10:
      label = 'activé';
      break;
    case 20:
      label = 'utilisé';
      break;
    case 90:
      label = 'désactivée';
      break;
    default:
      label = 'inconnu';
  }

  return label;
}

export const userStatusLabel = status => {
  var label;
  switch (status) {
    case 10:
      label = 'actif';
      break;
    case 90:
      label = 'suspendu	';
      break;
    default:
      label = 'inconnu';
  }

  return label;
}

/**
 * Date rendue au format ISO 8601, pour un champ d'API déclaré `String`.
 *
 * ⚠️ Sans cette conversion explicite, graphql-js sérialise un objet `Date` en appelant
 * son `valueOf()` — un **nombre** de millisecondes — puis le convertit en chaîne. L'API
 * livrait donc `"1785621636000"`, que `new Date()` refuse de relire : seul un nombre ou
 * une date ISO lui convient. D'où les « Invalid Date » de l'historique des rapports
 * d'alarmes (issue #285), de l'administration des accès et du paramétrage.
 *
 * @param {Date|string|number|null|undefined} value
 * @returns {string|null} date ISO, ou `null` si la valeur est absente ou illisible
 */
export const dateIso = value => {
  if (value === undefined || value === null || value === '') return null

  const date = value instanceof Date ? value : new Date(value)
  return Number.isNaN(date.getTime()) ? null : date.toISOString()
}

export const dateLabelToDate = date => {
  var strSplited = date.match(/\d+/g)

  return new Date(strSplited[2], parseInt(strSplited[1]) - 1, strSplited[0], strSplited[3] || 0, strSplited[4] || 0, strSplited[5] || 0)
}

export const dateLabel = date => {
  try {
    if(! date)
      return undefined

    var d = new Date(date)
    if(! d instanceof Date || isNaN(d))
      d = new Date(parseInt(date, 10))
    if(! d instanceof Date || isNaN(d))
      return undefined
    else
      return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear()
  } catch (err) {
    return date;
  }
}

export const dateTimeLabel = date => {
  try {
    if(! date)
      return undefined

    var d = new Date(date)
    if(! d instanceof Date || isNaN(d))
      d = new Date(parseInt(date, 10))
    if(! d instanceof Date || isNaN(d))
      return undefined
    else
      return d.toLocaleString()
  } catch (err) {
    return undefined;
  }
}

export const secretKeyLabel = secretKey => {
  if (!_.isString(secretKey)) return secretKey;

  return _.size(secretKey) > 0
    ? secretKey.match(new RegExp('.{1,' + 4 + '}', 'g')).join(' - ')
    : secretKey;
  // (secretKey.substring(0, 3) + " - " + secretKey.substring(3, 6) + " - " + secretKey.substring(6, 10)).toUpperCase()
}

export const checkPasswordFormat = password => {
  if(_.size(password) < 8){
    return false
  }

  if(! /\d/.test(password)){
    return false
  }

  if(! /[a-z]/.test(password)){
    return false
  }

  if(! /[A-Z]/.test(password)){
    return false
  }

  return true
}

export const checkEmailFormat = email => {
  return email && email !== "" && /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/.test(email)
}

export const getFormatedValue = (value, defaultValue) => {
  if(_.isDate(value))
    // 🔧 CORRECTION : Envoyer au format ISO au lieu de timestamp Unix
    // pour éviter le décalage de 2h dû à la conversion timezone
    return '"' + new Date(value).toISOString() + '"'
  if(typeof value === "object")
    // return JSON.stringify(value).replace(/\"/g, '')
    return (JSON.stringify(value) || "").replace(/\"([^"]+)\"\:/g, "$1:")
  if(typeof value === "string")
    return '"' + value + '"'
  if(typeof value === "boolean")
    return value ? 1 : 0
  if(value === undefined && defaultValue !== undefined)
    return '"' + defaultValue + '"'
  
  return value
}

/**
 * Get current owner name(s) from housing contacts or legacy data
 * @param {Object} housing - Housing object with currentContacts or legacy fields
 * @returns {string} Owner name(s), multiple names separated by commas if several current owners
 */
export const getOwnerName = (housing) => {
  if (!housing) return '';
  
  // Try new system first (currentContacts)
  if (housing.currentContacts && Array.isArray(housing.currentContacts)) {
    const owners = housing.currentContacts.filter(c => c.type === 'owner' && c.name)
    if (owners.length > 0) {
      return owners.map(o => o.name).join(', ')
    }
  }
  
  // Fallback to legacy system
  if (housing.apartment) {
    const apartment = safeParse(housing.apartment) || {}
    return apartment.lastname || ''
  }
  
  return housing.lastname || ''
}

/**
 * Get current tenant name(s) from housing contacts or legacy data
 * @param {Object} housing - Housing object with currentContacts or legacy fields
 * @returns {string} Tenant name(s), multiple names separated by commas if several current tenants
 */
export const getTenantName = (housing) => {
  if (!housing) return '';
  
  // Try new system first (currentContacts)
  if (housing.currentContacts && Array.isArray(housing.currentContacts)) {
    const tenants = housing.currentContacts.filter(c => c.type === 'tenant' && c.name)
    if (tenants.length > 0) {
      return tenants.map(t => t.name).join(', ')
    }
  }
  
  // Fallback to legacy system
  if (housing.apartment) {
    const apartment = safeParse(housing.apartment) || {}
    return apartment.loc_lastname || ''
  }
  
  return housing.loc_lastname || ''
}

/**
 * Get current owner phone(s) from housing contacts or legacy data
 * @param {Object} housing - Housing object with currentContacts or legacy fields
 * @returns {string} Owner phone(s), multiple phones separated by commas if several current owners
 */
export const getOwnerPhone = (housing) => {
  if (!housing) return '';
  
  // Try new system first (currentContacts)
  if (housing.currentContacts && Array.isArray(housing.currentContacts)) {
    const owners = housing.currentContacts.filter(c => c.type === 'owner' && c.tel)
    if (owners.length > 0) {
      return owners.map(o => o.tel).filter(tel => tel).join(', ')
    }
  }
  
  // Fallback to legacy system
  if (housing.apartment) {
    const apartment = safeParse(housing.apartment) || {}
    return apartment.phone || ''
  }
  
  return housing.phone || ''
}

/**
 * Get current tenant phone(s) from housing contacts or legacy data
 * @param {Object} housing - Housing object with currentContacts or legacy fields
 * @returns {string} Tenant phone(s), multiple phones separated by commas if several current tenants
 */
export const getTenantPhone = (housing) => {
  if (!housing) return '';
  
  // Try new system first (currentContacts)
  if (housing.currentContacts && Array.isArray(housing.currentContacts)) {
    const tenants = housing.currentContacts.filter(c => c.type === 'tenant' && c.tel)
    if (tenants.length > 0) {
      return tenants.map(t => t.tel).filter(tel => tel).join(', ')
    }
  }
  
  // Fallback to legacy system
  if (housing.apartment) {
    const apartment = safeParse(housing.apartment) || {}
    return apartment.loc_phone || ''
  }
  
  return housing.loc_phone || ''
}

/**
 * Get current owner email(s) from housing contacts or legacy data
 * @param {Object} housing - Housing object with currentContacts or legacy fields
 * @returns {string} Owner email(s), multiple emails separated by commas if several current owners
 */
export const getOwnerEmail = (housing) => {
  if (!housing) return '';
  
  // Try new system first (currentContacts)
  if (housing.currentContacts && Array.isArray(housing.currentContacts)) {
    const owners = housing.currentContacts.filter(c => c.type === 'owner' && c.email)
    if (owners.length > 0) {
      return owners.map(o => o.email).filter(email => email).join(', ')
    }
  }
  
  // Fallback to legacy system
  if (housing.apartment) {
    const apartment = safeParse(housing.apartment) || {}
    return apartment.email || ''
  }
  
  return housing.email || ''
}

/**
 * Get current tenant email(s) from housing contacts or legacy data
 * @param {Object} housing - Housing object with currentContacts or legacy fields
 * @returns {string} Tenant email(s), multiple emails separated by commas if several current tenants
 */
export const getTenantEmail = (housing) => {
  if (!housing) return '';
  
  // Try new system first (currentContacts)
  if (housing.currentContacts && Array.isArray(housing.currentContacts)) {
    const tenants = housing.currentContacts.filter(c => c.type === 'tenant' && c.email)
    if (tenants.length > 0) {
      return tenants.map(t => t.email).filter(email => email).join(', ')
    }
  }
  
  // Fallback to legacy system
  if (housing.apartment) {
    const apartment = safeParse(housing.apartment) || {}
    return apartment.loc_email || ''
  }
  
  return housing.loc_email || ''
}

export const getHousingLabel = (housing, housingGroup) => {
  var labels = [];
  labels.push(getHousingGroupLabel(housingGroup));

  if(housing.apartment){
    var apartment = safeParse(housing.apartment) || {}
    labels.push(apartment.apartmentNumber);
    labels.push(apartment.floor);
    labels.push(getOwnerName(housing));
    const tenantName = getTenantName(housing);
    if(tenantName){
      labels.push(`Loc: ${tenantName}`);
    }
  }else{
    labels.push(housing.apartmentNumber);
    labels.push(housing.floor);
    labels.push(getOwnerName(housing));
    const tenantName = getTenantName(housing);
    if(tenantName){
      labels.push(`Loc: ${tenantName}`);
    }
  }
  labels = _.filter(
    labels,
    label => label !== undefined && label !== null && label.trim() !== '',
  );

  return labels.join(' - ');
}

export const getDeviceLabel = device => {
  return device.serial;
}

export const getBoxStatusList = () => {
  return boxStatusList;
}

export const getDeviceStatusList = () => {
  return deviceStatusList;
}

export const getDeviceTypeList = () => {
  return deviceTypeList;
}

export const deviceStatusLabel = status => {
  return deviceStatusList[status];
}

export const deviceTypeLabel = type => {
  return deviceTypeList[type];
}

export const getValueStatusList = () => {
  return valueStatusList;
}

export const getValueStatusLabel = status => {
  return valueStatusList[status];
}

export const getAccessStatusList = () => {
  return accessStatusList;
}

export const getAccessStatusLabel = status => {
  return accessStatusList[status];
}

export const getDocumentStatusList = () => {
  return documentStatusList;
}

export const getDocumentTypeList = () => {
  return documentTypeList;
}

/**
 * Clés techniques de `origin` : elles servent à retrouver le fichier de trames d'origine
 * et ne doivent **jamais** être affichées. `f` porte l'identifiant de la ligne `ftpFile`,
 * `fn` son nom de fichier (état transitoire, le temps de l'import).
 */
export const ORIGIN_INTERNAL_KEYS = ["f", "fn"]

/**
 * `origin` débarrassé de ses clés techniques, pour tout affichage.
 * Passer par cette fonction plutôt que d'énumérer les clés sur place : un ajout futur à
 * `ORIGIN_INTERNAL_KEYS` doit suffire à le masquer partout.
 */
export const omitOriginInternals = origin => {
  const parsed = safeParse(origin)
  if(! _.isObject(parsed)){
    return parsed
  }

  return _.omit(parsed, ORIGIN_INTERNAL_KEYS)
}

/**
 * Référence du fichier de trames d'origine d'un relevé, ou `undefined`.
 * Sert à décider si la cellule « origine » est cliquable, et à construire son adresse.
 */
export const getOriginFrameRef = (meterReading) => {
  const origin = safeParse(meterReading && meterReading.origin)
  if(! origin || ! origin.uid || ! origin.TS){
    return undefined
  }

  return { uid: `${origin.uid}`, ts: `${origin.TS}`, ftpFileId: origin.f }
}

/**
 * Adresse de la page de trames d'un relevé.
 *
 * L'identifiant du fichier est ajouté quand le relevé le porte (`origin.f`, inscrit par les
 * chargeurs) : le résolveur n'a alors aucune recherche à faire. Sans lui — tout l'historique
 * antérieur — il retombe sur la résolution par nom, puis par contenu.
 */
export const getOriginFrameUrl = (meterReading) => {
  const ref = getOriginFrameRef(meterReading)
  if(! ref){
    return undefined
  }

  return ref.ftpFileId
    ? `/ftpframe/${ref.uid}/${ref.ts}/${ref.ftpFileId}`
    : `/ftpframe/${ref.uid}/${ref.ts}`
}

export const getOriginShortLabel = (meterReading) => {
  let origin = safeParse(meterReading.origin)
  if(! origin || (! origin.source && ! origin.src)){
    return ""
  }

  return origin.source || origin.src
}

export const documentStatusLabel = status => {
  return documentStatusList[status];
}

export const documentTypeLabel = type => {
  return documentTypeList[type];
}


export const getAttributesAlarmLabel = (alarm, t) => {
  let attributes = safeParseDeep(alarm.attributes) || {}
  if (!_.isObject(attributes)) attributes = {}
  let attributesStr = []
  switch(alarm.type){
    case 10: // daily meter
      attributesStr.push(t("alarms.table.datereading") + " : " + dateTimeLabel(new Date(attributes.lastMeterDate)))
      break
    case 11: // inverse flow
      attributesStr.push(t("alarms.table.datereading") + " : " + dateTimeLabel(new Date(attributes.lastMeterDate)))
      break
    case 12: // partial flow
      attributesStr.push(t("alarms.table.datereading") + " : " + dateTimeLabel(new Date(attributes.lastMeterDate)))
      break
    case 13: // negative flow
      attributesStr.push(t("alarms.table.datereading") + " : " + dateTimeLabel(new Date(Number(attributes.reading_date))) + " / index : " + attributes.reading_index + " / flow : " + attributes.negative_flow)
      break
    case 14: // absence consumption
      attributesStr.push(t("alarms.table.consumption") + " : " + (Math.round((attributes.consumption || 0) * 1000)) + " L")
      if (attributes.absence_start) attributesStr.push(t("alarms.table.absenceperiod") + " : " + dateTimeLabel(new Date(attributes.absence_start)) + " - " + dateTimeLabel(new Date(attributes.absence_end)))
      break
    case 15: // monthly threshold
    case 16: // yearly threshold
      {
        const key = attributes.period_key
        let periodLabel = key || ''
        if (alarm.type === 15 && key && key.length === 6) periodLabel = key.slice(4, 6) + "/" + key.slice(0, 4)
        attributesStr.push(t("alarms.table.period") + " : " + periodLabel)
        if (attributes.consumption !== undefined) attributesStr.push(t("alarms.table.consumption") + " : " + attributes.consumption)
        if (attributes.threshold !== undefined) attributesStr.push(t("alarms.table.threshold") + " : " + attributes.threshold)
      }
      break
    case 20: // alarm from device
      attributesStr.push(t("alarms.table.alarms") + " : " + alarmsLabel(t, attributes.alarms))
      attributesStr.push(t("alarms.table.datereading") + " : " + dateTimeLabel(new Date(attributes.dateReading)))
      break
    case 30: // box
      // `currentMeterFileDate` est le dernier fichier reellement recu, rafraichi tant que
      // l'alarme court ; `lastMeterFileDate` est fige au declenchement et sert a la duree.
      // ⚠️ Le TRI de cette colonne vit ailleurs : `case "date"` du `switch` sortBy de
      // `domains/alarm/alarmBox.js`. Changer l'attribut affiche ici sans l'y reporter
      // trie la liste sur une valeur qu'elle ne montre pas — c'est le defaut de #302.
      // Afficher le second donnait une date perimee des que le boitier redonnait signe de
      // vie sans reprendre son rythme, ce qui se lisait comme une alarme restee a tort
      // (#326). Le repli couvre les alarmes anterieures, qui n'ont pas le nouvel attribut.
      // `getTime` et non `new Date` : l'attribut peut arriver en chaîne de millisecondes,
      // que `new Date` ne sait pas lire — la colonne affichait alors « undefined ».
      attributesStr.push(t("alarms.table.datereading") + " : " + dateTimeLabel(new Date(getTime(attributes.currentMeterFileDate ?? attributes.lastMeterFileDate))))
      break
    default:
      _.forEach(attributes, (value, key) =>{
        attributesStr.push(key + " : " + value)
      })
  }

  return attributesStr.join(" / ")
}

/**
 * Retourne le libellé simplifié d'une alarme pour les tooltips
 * - Type 20 : les alarmes dans attributes.alarms
 * - Autres types : le libellé du type
 */
export const getAlarmTooltipLabel = (alarm, t) => {
  if (alarm.type === 20) {
    const attributes = safeParse(alarm.attributes) || {}
    return alarmsLabel(t, attributes.alarms)
  }
  return t("global.alarm.type_" + alarm.type)
}

export const getUrlParams = queryParams => {
  var params = {};

  if (!queryParams) return params;

  params = _.transform(
    queryParams.split('#'),
    (res, v) => {
      var vSplited = v.split(':');
      res[vSplited[0]] = vSplited[1];
    },
    {},
  );

  return params;
}

export const setQueryParams = (queryParams, paramsToRemove, newParams) => {
  if (!queryParams) return '';

  var newQueryParams = newParams ? _.assign({}, queryParams, newParams) : queryParams;

  var res;

  if (paramsToRemove !== undefined) {
    newQueryParams = _.pickBy(newQueryParams, (v, k) => paramsToRemove.indexOf(k) === -1)
  }

  res = _.transform(
    newQueryParams,
    (result, v, k) => result.push(k + '=' + v),
    [],
  ).join('&');
  
  return res === '' ? '' : '?' + res;
}

export const getDataTypeList = (deviceType) => {
  const deviceTypeModel = {
    water: ["vol"]
    , heater: ["energy", "volume", "curFlow", "curPower", "forwardTemp", "backTemp", "diffTemp"]
    , box: ["sw", "temp", "batCap", "nwMode", "signal", "batPrcent", "nwOperator"]
  }

  if(deviceType === undefined)
    return deviceTypeModel

  switch(deviceType){
    case 10:
    case 20:
    case "water":
      return deviceTypeModel.water
      break
    case 30:
    case "heater":
      return deviceTypeModel.heater
      break
    case "box":
      return deviceTypeModel.box
      break
  }
}

export const logLabel = (t, log, language) => {
  if(! log)
      return '??'

  if(log.type == "emailSent"){
    let label = log.email || ""
    if(log.comment){
      label += (label ? " / " : "") + log.comment
    }
    return label
  }

  if(log.date_start && log.date_end && log.alarms){
    return t('alarms.startAndEndAndAlarms', {start: dateLabel(log.date_start), end: dateLabel(log.date_end), alarms: log.alarms}) + (log.comment ? " / " + log.comment : "")
  }
  
  if(log.date_start && log.date_end && log.emulateIndexes){
    return t('alarms.startAndEnd', {start: dateLabel(log.date_start), end: dateLabel(log.date_end)}) + " " +  t('alarms.emulateIndexes') + (log.comment ? " / " + log.comment : "")
  }
  
  if(log.date_start && log.date_end){
    return t('alarms.startAndEnd', {start: dateLabel(log.date_start), end: dateLabel(log.date_end)}) + (log.comment ? " / " + log.comment : "")
  }

  // Alarme encore ouverte (#303). Toutes les branches ci-dessus exigent une date de FIN :
  // sans celle-ci, la ligne tombait jusqu'au `return log.comment` final et n'affichait rien.
  // Ce cas n'existe que pour les lignes cousues par le résolveur `deviceLog` — les logs
  // écrits en base ont toujours leurs deux dates.
  if(log.date_start && ! log.date_end){
    const cle = log.alarms ? 'alarms.startAndInProgressAndAlarms' : 'alarms.startAndInProgress'
    return t(cle, {start: dateLabel(log.date_start), alarms: log.alarms}) + (log.comment ? " / " + log.comment : "")
  }

  if(log.type == "replacement"){
    let label = ""
    if(log.replacementSerial){
      label = t('deviceset.adddevicelog.replacementlabel') + " " + log.replacementSerial
    }
    if(log.comment){
      label += (label ? " / " : "") + log.comment
    }
    return label || log.comment || ""
  }

  // Gestion spécifique pour les alarmes inverseFlow avec flow (type 20)
  if((log.type === 20 || log.type == "20") && log.alarms === "inverseFlow" && log.flow !== undefined){
    let label = t('alarms.types.inverseFlow')
    if(log.flow !== null && log.flow !== undefined){
      label += " - " + log.flow + " L"
    }
    if(log.comment){
      label += (label ? " / " : "") + log.comment
    }
    return label
  }

  if(log.alarms){
    return alarmsLabel(t, log.alarms)
  }

  return log.comment
}

export const alarmsLabel = (t, alarms, language) => {
  try {
    if(! alarms)
      return '??'

    var res = '';
    alarms.split(',').forEach(alarm => {
      res += (res.length > 0 ? ' + ' : '') +  t('alarms.types.' + alarm)
    })
    return res;
  } catch (err) {
    return err.toString();
  }
}

export const getOrigin = (meterReading) => {
  var origin = safeParse(meterReading && meterReading.origin)
  if(! origin)
    return ""

  // Le nom de fichier était **reconstruit** ici, en `{uid}-{TS}-data.bson`. Deux erreurs :
  // les fichiers lora sont des `.json.gz` (ce `-data.bson` n'existe jamais), et côté webdyn
  // `TS` diffère de l'horodatage du nom de 1 à 3 s dans une bonne part des cas. La page
  // affichait donc, en toute confiance, un nom de fichier introuvable sur le serveur FTP.
  // Le nom réel demande une résolution en base : c'est le rôle de `pickFtpFileForOrigin`,
  // via la route `/ftpframe`. Ici on se borne à ce qui est vrai.
  if(origin.source == "ftp"){
    return `origin : ftp, boitier : ${origin.uid}`
  }

  return JSON.stringify(_.pickBy(omitOriginInternals(origin), (v, k) => ["TS", "uid"].indexOf(k) === -1)).replaceAll(/[\{\}]/g, "").replaceAll(/\"([^"]+)\"\:/g, "$1 : ")
}



export const getSignal = (meterReading) => {
  var origin = meterReading && meterReading.origin
  if(! origin || origin.S === undefined){
    return ""
  }

  return origin.S
}

// return buffered image
export const imageToBuffer = (urls) => {
  var res = {}

  return Promise.mapSeries(_.transform(urls, (res, url, key) => {res.push({key, url})}, []), entry => {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var reader = new FileReader()
        reader.onloadend = function() {
          res[entry.key] = reader.result
          resolve()
        }
        reader.readAsDataURL(xhr.response)
      };
      
      xhr.open('GET', entry.url)
      xhr.responseType = 'blob'
      xhr.send()
    })
  }).then(() => {
    return res
  })
}

// unzip un buffer
export const  decompressArrayBuffer = async (input) =>{
  //create the stream
  const ds = new DecompressionStream("gzip")
  //create the writer
  const writer = ds.writable.getWriter()
  //write the buffer to the writer thus decompressing it 
  writer.write(input)
  writer.close()
  //create the output
  const output = []
  //create the reader
  const reader = ds.readable.getReader()
  let totalSize = 0
  //go through each chunk and add it to the output
  while (true) {
    const { value, done } = await reader.read()
    if (done) break
    output.push(value)
    totalSize += value.byteLength
  }
  const concatenated = new Uint8Array(totalSize)
  let offset = 0
  //finally build the compressed array and return it 
  for (const array of output) {
    concatenated.set(array, offset)
    offset += array.byteLength
  }

  return concatenated
}

export function isDateTooOld(date, jointHousingGroup){
  let attributes = jointHousingGroup?.attributes
  attributes = attributes ? safeParse(attributes) : undefined
  let nbDay = attributes?.updateAlarmBoxNbDay !== undefined ? parseInt(attributes.updateAlarmBoxNbDay) : 2
  
  if(!date){
    return false
  }
  
  let dateReading = new Date(date)
  
  return dateReading.getTime() < new Date().getTime() - 1000 * 60 * 60 * 24 * nbDay
}

export function getTime(o) {
  try {
    let date = o
    if(! _.isDate(o)){
      let _integer = parseInt(o)
      
      if(! _.isNaN(_integer) && "" + _integer === "" + o){
        date = new Date(parseInt(o))
      }else{
        date = new Date(o)
      }
    }
    if(_.isDate(date)){
      return date.getTime()
    }

    return undefined
  } catch (error) {
    return undefined
  }
}

export function autoTableDateFormat(d) {
  if(! d){
    return undefined
  }
  let date = new Date(d)
  if(! _.isDate(date)){
    return undefined
  }
  
  return `${date.getFullYear()}_${(date.getMonth() + 1).toString().padStart(2, '0')}_${(date.getDate()).toString().padStart(2, '0')}`
}